enum InvoiceCollectionMethod {
    CHARGE_AUTOMATICALLY = 'charge_automatically',
    SEND_INVOICE = 'send_invoice',
}

export default InvoiceCollectionMethod;
